<app-onb-moldura passo="loja" [estado]="estado" subtitulo="Como o cliente recebe o pedido e de onde ele sai.">

  <div class="onb-grupo-rot">Como o cliente recebe <span class="pl-mia" *ngIf="operacaoDaMia"><i class="fas fa-magic"></i> Anotado pela Mia</span></div>
  <div class="onb-grupo" id="onb-loja-modos">
    <div class="onb-linha">
      <span class="onb-ic onb-ic--loja"><i class="fas fa-motorcycle"></i></span>
      <div class="onb-tx"><b>Entrega</b><span>Você leva até o cliente.</span></div>
      <label class="onb-sw"><input type="checkbox" id="onb-loja-delivery" [(ngModel)]="delivery" aria-label="Entrega"><span></span></label>
    </div>
    <div class="onb-linha">
      <span class="onb-ic onb-ic--loja"><i class="fas fa-shopping-bag"></i></span>
      <div class="onb-tx"><b>Retirada no balcão</b><span>O cliente busca na loja.</span></div>
      <label class="onb-sw"><input type="checkbox" id="onb-loja-retirada" [(ngModel)]="retirada" aria-label="Retirada"><span></span></label>
    </div>
  </div>

  <div class="onb-grupo-rot">Endereço da loja</div>
  <div class="onb-grupo">
    <div class="onb-linha" *ngIf="manterEndereco">
      <span class="onb-ic onb-ic--neutro"><i class="fas fa-map-marker-alt"></i></span>
      <div class="onb-tx"><b>{{ enderecoSalvo }}</b><span>É daqui que o pedido sai e onde o cliente retira.</span></div>
      <button type="button" class="onb-btn onb-btn--sec" (click)="troqueEndereco()">Trocar</button>
    </div>
    <ng-container *ngIf="!manterEndereco">
      <div class="onb-campos">
        <div class="onb-campo">
          <label for="onb-cep">CEP</label>
          <input class="onb-inp" id="onb-cep" [(ngModel)]="cep" (input)="aoDigitarCep()" inputmode="numeric" maxlength="9" placeholder="00000-000">
        </div>
        <div class="onb-campo pl-rua">
          <label for="onb-rua">Rua</label>
          <input class="onb-inp" id="onb-rua" [(ngModel)]="rua" autocomplete="address-line1">
        </div>
        <div class="onb-campo">
          <label for="onb-numero">Número</label>
          <input class="onb-inp" id="onb-numero" [(ngModel)]="numero" placeholder="120 ou s/n">
        </div>
      </div>
      <div class="onb-campos">
        <div class="onb-campo"><label for="onb-compl">Complemento</label><input class="onb-inp" id="onb-compl" [(ngModel)]="complemento" placeholder="opcional"></div>
        <div class="onb-campo"><label for="onb-bairro">Bairro</label><input class="onb-inp" id="onb-bairro" [(ngModel)]="bairro"></div>
        <div class="onb-campo"><label for="onb-cidade">Cidade</label><input class="onb-inp" id="onb-cidade" [(ngModel)]="cidade"></div>
        <div class="onb-campo pl-uf"><label for="onb-uf">UF</label><input class="onb-inp" id="onb-uf" [(ngModel)]="uf" maxlength="2"></div>
      </div>
      <p class="pl-aviso" *ngIf="buscandoCep || avisoCep">{{ buscandoCep ? 'Buscando o CEP…' : avisoCep }}</p>
    </ng-container>
  </div>

  <ng-container *ngIf="delivery">
    <div class="onb-grupo-rot">Entrega</div>
    <div class="onb-grupo">
      <div class="onb-linha">
        <div class="onb-tx"><b>Taxa única de entrega</b><span>Comece simples. Por bairro ou por distância você ajusta depois em Formas de entrega.</span></div>
      </div>
      <div class="onb-campos">
        <div class="onb-campo">
          <label for="onb-taxa">Taxa</label>
          <div class="onb-prefixo"><span>R$</span><input class="onb-inp" id="onb-taxa" [(ngModel)]="taxa" inputmode="decimal" placeholder="0,00"></div>
        </div>
        <div class="onb-campo">
          <label for="onb-tmin">Tempo de entrega, de</label>
          <div class="onb-sufixo"><input class="onb-inp" id="onb-tmin" [(ngModel)]="tempoMinimo" inputmode="numeric"><span>min</span></div>
        </div>
        <div class="onb-campo">
          <label for="onb-tmax">até</label>
          <div class="onb-sufixo"><input class="onb-inp" id="onb-tmax" [(ngModel)]="tempoMaximo" inputmode="numeric"><span>min</span></div>
        </div>
        <div class="onb-campo">
          <label for="onb-minimo">Pedido mínimo</label>
          <div class="onb-prefixo"><span>R$</span><input class="onb-inp" id="onb-minimo" [(ngModel)]="pedidoMinimo" inputmode="decimal" placeholder="opcional"></div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="retirada">
    <div class="onb-grupo-rot">Retirada</div>
    <div class="onb-grupo">
      <div class="onb-campos">
        <div class="onb-campo">
          <label for="onb-rmin">Fica pronto em, de</label>
          <div class="onb-sufixo"><input class="onb-inp" id="onb-rmin" [(ngModel)]="tempoRetiradaMinimo" inputmode="numeric"><span>min</span></div>
        </div>
        <div class="onb-campo">
          <label for="onb-rmax">até</label>
          <div class="onb-sufixo"><input class="onb-inp" id="onb-rmax" [(ngModel)]="tempoRetiradaMaximo" inputmode="numeric"><span>min</span></div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="pl-previa" *ngIf="previa">
    <i class="far fa-eye"></i><span>O cliente vê: <b>{{ previa }}</b></span>
  </div>

  <div class="onb-erro" *ngIf="erro">{{ erro }}</div>

  <div class="onb-rodape">
    <span class="onb-dica">{{ dica }}</span>
    <a class="onb-btn onb-btn--link" routerLink="/admin/comecar">Fazer depois</a>
    <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="salve()">
      {{ salvando ? 'Salvando…' : 'Salvar e continuar' }}
    </button>
  </div>
</app-onb-moldura>
